import StarterKit from '@tiptap/starter-kit'
import Highlight from '@tiptap/extension-highlight'
import Underline from '@tiptap/extension-underline'
import Placeholder from '@tiptap/extension-placeholder'
import CodeBlockLowlight from '@tiptap/extension-code-block-lowlight'
import TaskList from '@tiptap/extension-task-list'
import TaskItem from '@tiptap/extension-task-item'
import Image from '@tiptap/extension-image'
import { common, createLowlight } from 'lowlight'
import { EmDash } from '@/lib/emDashExtension'

const lowlight = createLowlight(common)

export const buildExtensions = (placeholderFn: () => string) => [
  // «--» → «—», как во всех полях студии (`lib/emDash.ts`).
  EmDash,
  StarterKit.configure({
    codeBlock: false,
    link: {
      openOnClick: false,
      autolink: true,
      linkOnPaste: true,
      HTMLAttributes: {
        target: '_blank',
        rel: 'noopener noreferrer',
      },
    },
  }),
  Highlight,
  Underline,
  Placeholder.configure({ placeholder: () => placeholderFn() }),
  CodeBlockLowlight.configure({ lowlight }),
  TaskList,
  TaskItem.configure({ nested: true }),
  Image,
]
